import { UserBillingInfoDto } from './billingInfo';
import { PaymentFrequencyType, PaymentType } from './payment';

export type BaseOrder = {
  id: string;
  paymentSystemId?: string;
  paymentType: PaymentType;
  status: OrderStatus;
  user: string;
  data: OrderData;
  userBillingInfo?: { '@id': string };
};

export interface ServerOrder extends BaseOrder {
  statusChangedTs: string;
  created: string;
}

export interface Order extends BaseOrder {
  statusChangedTs: Date;
  created: Date;
}

export enum OrderStatus {
  PLACED = 'PLACED',
  CANCELED = 'CANCELED',
  APPROVED = 'APPROVED',
  OFFER = 'OFFER',
  SUBSCRIBED = 'SUBSCRIBED',
  REVOKED = 'REVOKED',
}

export type OrderData = {
  planId: number;
  name: string;
  description: string;
  currency: 'EUR';
  netAmount: number;
  vatAmount: number;
  grossAmount: number;
  paymentFrequencyType: PaymentFrequencyType;
  paymentFrequency?: string;
  payPalAgreementPlanId?: string;
  paymentOptions?: PaymentType[];
};

export type OrderPurchasePayload = {
  user: string;
  status: OrderStatus;
  data: OrderData;
  paymentType: PaymentType;
  userBillingInfo: UserBillingInfoDto;
};

export interface OrderConfirmPayload extends OrderPurchasePayload {
  id: string;
}

export function mapOrder(order: ServerOrder): Order {
  return {
    ...order,
    statusChangedTs: new Date(order.statusChangedTs),
    created: new Date(order.created),
  };
}

export function isCancalable(order: Order): boolean {
  return (
    order &&
    (order.status === OrderStatus.APPROVED ||
      order.status === OrderStatus.PLACED ||
      order.status === OrderStatus.OFFER)
  );
}
